import { Box, H4 } from '@deity/falcon-ui';
import KeyValueTable, { KeyValidators } from 'components/FieldEditorControls/KeyValueTable';
import type { FC } from 'react';

interface IMethodProps {
  isEditable: boolean;
  variables: Record<string, string>;
  onChange: (path: string[], val: {}) => void;
}
export const Variables: FC<IMethodProps> = ({ isEditable, variables, onChange }) => (
  <Box p="xxl">
    <H4 mb="xs" fontWeight="semiBold" fontSize="xl">
      Variables
    </H4>
    <KeyValueTable
      key="variables"
      isEditable={isEditable}
      keyValidator={KeyValidators.NO_WHITE_SPACE}
      persistedValue={variables}
      onTableValueChange={(key, val) => onChange(['variables'], val)}
    />
  </Box>
);
